import React from 'react';
import styles from './Footer.module.scss';

const Footer = () => <footer className={styles.footer} />;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx